import React from 'react';

const EmptyStateIcon = (props) => {
  return (
    <svg
      width="197"
      height="260"
      viewBox="0 0 197 260"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M102.622 260C154.362 260 196.305 251.502 196.305 241.02C196.305 230.537 154.362 222.039 102.622 222.039C50.8827 222.039 8.93945 230.537 8.93945 241.02C8.93945 251.502 50.8827 260 102.622 260Z"
        fill="#6D7878"
        fillOpacity="0.2"
      />
      <path
        d="M165.159 28.6797L12.8034 53.9294C5.73228 55.1013 0.950001 61.7835 2.12189 68.8547L11.6421 126.299C12.814 133.37 19.4963 138.153 26.5674 136.981L178.923 111.731C185.995 110.559 190.777 103.877 189.605 96.8058L180.085 39.3613C178.913 32.2901 172.231 27.5079 165.159 28.6797Z"
        fill="#15AFE6"
      />
      <path
        d="M135.129 82.3974L168.72 76.8236C168.226 68.3145 163.361 51.8734 147.876 54.1656C132.392 56.4578 132.919 73.9378 135.129 82.3974Z"
        fill="white"
      />
      <path
        d="M28.3542 100.092L63.6275 94.2381C63.1658 85.729 58.2021 69.3044 41.9589 71.712C25.7157 74.1196 26.128 91.6326 28.3542 100.076V100.092Z"
        fill="white"
      />
      <path
        d="M163.689 52.0888C164.151 53.0617 165.322 53.474 166.295 53.0122C167.268 52.5505 167.68 51.3796 167.218 50.4067L163.706 52.0888H163.689ZM137.172 40.7927C136.167 41.1885 135.688 42.3264 136.084 43.3158C136.48 44.3217 137.618 44.7999 138.607 44.4042L137.172 40.7762V40.7927ZM167.202 50.4067C165.718 47.323 162.486 43.2663 157.439 40.7927C152.327 38.2862 145.517 37.4946 137.172 40.7927L138.607 44.4207C145.995 41.5018 151.651 42.2934 155.724 44.2887C159.88 46.3335 162.535 49.6976 163.689 52.0888L167.202 50.4067Z"
        fill="#282827"
      />
      <path
        d="M28.9461 62.8073C28.4844 61.9333 27.3136 61.587 26.3572 62.0487C25.3842 62.5105 24.9884 63.5823 25.4501 64.4563L28.9461 62.8073ZM56.9306 72.5532C57.9365 72.1904 58.4643 71.1515 58.085 70.228C57.7222 69.3045 56.6008 68.8593 55.5949 69.2221L56.9306 72.5367V72.5532ZM25.4337 64.4563C26.9343 67.2762 30.2984 70.9206 35.5589 73.0644C40.8853 75.2246 48.0257 75.7853 56.9142 72.5696L55.5784 69.2551C47.597 72.1409 41.5284 71.5472 37.2079 69.7992C32.8214 68.0183 30.084 64.9675 28.9297 62.8238L25.4337 64.4728V64.4563Z"
        fill="#282827"
      />
      <path
        opacity="0.5"
        d="M153.621 95.0359C163.45 93.4069 170.915 89.049 170.294 85.3023C169.673 81.5555 161.202 79.8388 151.372 81.4679C141.543 83.0969 134.078 87.4548 134.699 91.2015C135.319 94.9482 143.791 96.6649 153.621 95.0359Z"
        fill="#3882C4"
      />
      <path
        opacity="0.5"
        d="M49.373 112.29C59.6697 110.583 67.5135 106.163 66.8926 102.416C66.2716 98.6692 57.4211 97.0152 47.1244 98.7217C36.8277 100.428 28.9838 104.849 29.6048 108.596C30.2257 112.342 39.0763 113.996 49.373 112.29Z"
        fill="#3882C4"
      />
      <path
        d="M106.53 0.0606457L64.1658 7.08563C61.8242 7.4814 60.241 9.69113 60.6368 12.0328C61.0326 14.3744 63.2423 15.9576 65.584 15.5618L107.948 8.5368C110.29 8.14103 111.873 5.9313 111.477 3.58964C111.081 1.24799 108.872 -0.335127 106.53 0.0606457Z"
        fill="#15AFE6"
      />
      <path
        d="M81.254 10.3511L88.279 52.7152C88.6748 55.0569 90.8845 56.64 93.2262 56.2442C95.5678 55.8484 97.1509 53.6387 96.7552 51.297L89.7302 8.93286C89.3344 6.5912 87.1247 5.00814 84.783 5.40391C82.4413 5.79968 80.8582 8.00941 81.254 10.3511Z"
        fill="#15AFE6"
      />
      <path
        d="M132.129 247.023H134.075V245.077H132.129V247.023ZM118.376 243.131C117.304 243.131 116.43 244.005 116.43 245.077C116.43 246.149 117.304 247.023 118.376 247.023V243.131ZM130.183 176.344V245.06H134.075V176.344H130.183ZM132.129 243.131H118.392V247.023H132.129V243.131Z"
        fill="#282827"
      />
      <path
        d="M132.129 247.023H134.075V245.077H132.129V247.023ZM118.376 243.131C117.304 243.131 116.43 244.005 116.43 245.077C116.43 246.149 117.304 247.023 118.376 247.023V243.131ZM130.183 176.344V245.06H134.075V176.344H130.183ZM132.129 243.131H118.392V247.023H132.129V243.131Z"
        fill="#282827"
      />
      <path
        d="M82.3082 247.023H84.2541V245.077H82.3082V247.023ZM70.2701 243.131C69.1983 243.131 68.3242 244.005 68.3242 245.077C68.3242 246.149 69.1983 247.023 70.2701 247.023V243.131ZM80.3459 176.344V245.06H84.2376V176.344H80.3459ZM82.3082 243.131H70.2866V247.023H82.3082V243.131Z"
        fill="#282827"
      />
      <path
        d="M139.862 135.117H72.8608C69.5462 135.117 66.8418 137.805 66.8418 141.136C66.8418 144.45 69.5297 147.155 72.8608 147.155H139.862C143.177 147.155 145.881 144.467 145.881 141.136C145.881 137.821 143.193 135.117 139.862 135.117Z"
        fill="#29255E"
      />
      <path
        d="M139.862 151.921H72.8608C69.5462 151.921 66.8418 154.609 66.8418 157.94C66.8418 161.255 69.5297 163.959 72.8608 163.959H139.862C143.177 163.959 145.881 161.272 145.881 157.94C145.881 154.626 143.193 151.921 139.862 151.921Z"
        fill="#29255E"
      />
      <path
        d="M139.862 167.769H72.8608C69.5462 167.769 66.8418 170.457 66.8418 173.788C66.8418 177.102 69.5297 179.807 72.8608 179.807H139.862C143.177 179.807 145.881 177.119 145.881 173.788C145.881 170.473 143.193 167.769 139.862 167.769Z"
        fill="#29255E"
      />
      <path
        d="M88.4277 103.851C88.4277 103.851 96.4916 95.8035 103.962 100.388"
        stroke="#282827"
        strokeWidth="1.256"
        strokeLinecap="round"
      />
      <path
        d="M42.4687 71.6612C40.0941 74.1348 38.8738 77.6473 39.4839 81.2917C40.5064 87.4262 46.2946 91.5818 52.429 90.5593C56.5517 89.8832 59.7673 87.0304 61.1361 83.386C58.2667 76.5589 52.6269 70.3914 42.4687 71.6612Z"
        fill="#010101"
        stroke="#010101"
        strokeWidth="0.312"
      />
      <path
        d="M147.398 53.818C145.024 56.2915 143.803 59.804 144.414 63.4484C145.436 69.5829 151.224 73.7386 157.359 72.7161C161.481 72.04 164.697 69.1872 166.066 65.5427C163.196 58.7157 157.557 52.5482 147.398 53.818Z"
        fill="#010101"
        stroke="#010101"
        strokeWidth="0.312"
      />
      <path
        d="M144.711 137.938L168.556 160.464L143.375 177.251C143.375 177.251 147.349 183.88 153.978 183.435"
        stroke="#282827"
        strokeWidth="1.888"
        strokeLinecap="round"
      />
      <path
        d="M52.1835 133.072C55.9631 133.072 59.027 130.008 59.027 126.229C59.027 122.449 55.9631 119.385 52.1835 119.385C48.4039 119.385 45.3398 122.449 45.3398 126.229C45.3398 130.008 48.4039 133.072 52.1835 133.072Z"
        fill="#282827"
      />
      <path
        d="M50.1992 121.151C50.1992 121.151 50.6445 115.412 55.938 112.757"
        stroke="#282827"
        strokeWidth="1.888"
        strokeLinecap="round"
      />
      <path
        d="M51.5203 130.863C51.5203 130.863 46.6557 155.154 49.7559 162.657L70.9627 143.231"
        stroke="#282827"
        strokeWidth="1.888"
        strokeLinecap="round"
      />
    </svg>
  );
};

export default EmptyStateIcon;